module.exports = "/static/assets/1c78a936bf640a0c11b21af1330d15df.png";